import script from "./Sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./Sidebar.vue?vue&type=style&index=0&id=9afe021c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9afe021c"]])

export default __exports__